var accordionButton = document.querySelectorAll('.accordion-content .headline');
accordionButton.forEach(function(item)  {
  item.addEventListener('click', function() {
    item.nextElementSibling.classList.toggle('open');
    item.parentNode.classList.toggle('active');
  });
});